export default class BaseDataService {
    constructor(baseUrl) {
        this.setBaseURL(baseUrl);
    }
    timer = null;
    uri = {};
    bearerToken = undefined;

    setBaseURL(_url) {
        this.uri.baseUrl = _url;
    }

    setIDs({ res, lang, user_sam, user_storage_name, user_source, session_id, storageName, patientId, record }) {
        this.resId = res;
        this.lang = lang;
        this.user_sam = user_sam;
        this.user_storage_name = user_storage_name;
        this.user_source = user_source;
        this.session_id = session_id;
        this.storageName = storageName;
        this.patientId = patientId;
        this.record = record;
        clearInterval(this.timer);
    }

    setOnResIDChangedCallback(_cb) {
        this._onResIDChangedCallback = _cb;
    }
    onResIDChangedCallback = _data => {
        if (typeof this._onResIDChangedCallback === "function") {
            this._onResIDChangedCallback(_data);
        } else {
            throw new Error("Standart ECG Report: Couldn't process redirect to new result instruction - there is no callback");
        }
    };
    startPingInterval() {
        clearInterval(this.timer);
        this.timer = setInterval(async () => {
            this.ping();
        }, 1000 * 60 * 5);
    }
    ping = async () => {
        let url = new URL(this.uri.baseUrl + this.uri.ping);
        this._addCommonSearchParams(url.searchParams);
        const reqRes = await fetch(url, { ...this._authHeader(), method: "GET" }).then(resp => {
            if (resp.ok) {
                return resp.text();
            }
            throw new Error("ERROR. Couldn't ping.");
        });
        return reqRes;
    };

    getReportData = async () => {
        let url = new URL(this.uri.baseUrl + this.uri.reportData);
        const sp = url.searchParams;

        this._addCommonSearchParams(sp);
        sp.append("lang", this.lang);

        return fetch(url, this._authHeader()).then(resp => {
            if (resp.ok) {
                this.startPingInterval();
                return resp.json();
            }
            throw new Error("ERROR. Get report data.");
        });
    };

    _addCommonSearchParams(sp) {
        const { resId, session_id, storageName, user_source, patientId, record } = this;
        if (resId) sp.append("res", resId);
        if (patientId) sp.append("patientId", patientId);
        if (storageName) sp.append("storageName", storageName);
        if (user_source) sp.append("sourceUser", user_source);
        if (session_id) sp.append("session_id", session_id);
        if (record) sp.append("record", record);

        this._addOtherUserParams(sp);
    }
    _addOtherUserParams(sp) {
        const { user_sam, user_storage_name } = this;
        if (user_sam) sp.append("resUser", user_sam);
        if (user_storage_name) sp.append("resStorageName", user_storage_name);
    }
}
